import React from 'react';
import './styles.css';
import logoSvg from "../../../assets/chanakyaLogo.svg"
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { setActiveUser } from '../../../redux/userSlice';
import { useDispatch } from 'react-redux';
import { ApiCollection } from '../../../config/envConfig';
import { LocalUser } from '../../../utils/interface/localUser';
import { toast } from 'react-toastify';
import { GoogleLogin } from '@react-oauth/google';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import paperanalysis from "../../../assets/paperanalysis.png"
import assessmentsPaper from "../../../assets/assesmentsPaper.png"
import { FaBookReader, FaRobot, FaBrain, FaChartLine } from 'react-icons/fa';
import { logEvent, logUserLogin } from '../../../utils/analytics/analytics';
import { useOneSignalUser } from '../../../hooks/useOneSignalUser';

const Spinner = () => (
  <div className="spinner"></div>
);

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [errors, setErrors] = React.useState({ username: '', password: '' });
  const [loading, setLoading] = React.useState(false);
  const { tagUser } = useOneSignalUser();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();


    setErrors({ username: '', password: '' });


    const newErrors = {
      username: !username ? 'Email is required' : '',
      password: !password ? 'Password is required' : ''
    };

    setErrors(newErrors);


    if (!newErrors.username && !newErrors.password) {
      onLoginPress();
    }
  };

  const onLoginPress = async () => {
    try {
      setLoading(true);
      logEvent('User', 'Login Attempt', 'Email Login');

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };

      const response = await axios.post(ApiCollection.user.login, {
        email: username,
        password,
      }, config);

      const { data: userData } = response;

      if (!userData) {
        throw new Error("No data received from server");
      }

      const userInfo: LocalUser = {
        id: userData.id,
        firstName: userData.first_name,
        lastName: userData.last_name,
        email: userData.email,
        isActive: userData.is_active,
        mobileNo: userData.mobile_number,
        token: userData.token,
        permissions: userData.permissions,
        role: userData.user_role,
        profile: userData.profile,
        dateOfBirth: userData.date_of_birth,
        organisation: {
          id: userData.organisations.id,
          name: userData.organisations.organisation_name,
          address: userData.organisations.organisation_address,
          contact: userData.organisations.organisation_contact_number,
          logo: null
        },
        educationalInfo: userData.educational_info ? {
          class: userData.educational_info.class,
          stream: userData.educational_info.stream
        } : null,
        subscription: userData.subscription ? {
          isSubscriptionActive: userData.subscription.is_subscription_active,
          startDate: userData.subscription.start_date,
          expiryDate: userData.subscription.expiry_date,
          isNewSubscription: userData.subscription.is_new_subscription,
          subscriptions: userData.subscription.subscriptions
        } : null
      };

      await tagUser({
        id: userData.id,
        email: userData.email,
        user_role: userData.user_role,
        mobile_number: userData.mobile_number,
        first_name: userData.first_name,
        last_name: userData.last_name,
        educational_info: {
          class: userData.educational_info?.class
        }
      });

      dispatch(setActiveUser(userInfo));

      if (window.OneSignal) {
        try {
          await window.OneSignal.showSlidedownPrompt();
        } catch (error) {
          console.error('Error showing OneSignal prompt:', error);
        }
      }

      logUserLogin({
        userId: userData.id,
        email: userData.email,
        name: `${userData.first_name} ${userData.last_name}`,
        user_role: userData.user_role,
        mobile_number: userData.mobile_number,
        first_name: userData.first_name,
        last_name: userData.last_name,
        educational_info: {
          class: userData.educational_info?.class
        }
      });

      logEvent('User', 'Login Success', 'Email Login');
      navigate('/');
      toast.success('Login successful!');

    } catch (error: any) {
      logEvent('Error', 'Login Failed', 'Email Login');
      console.log(error);

      const errorMessage = error.response?.data?.detail || "An error occurred during login";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async (credentialResponse: any) => {
    try {
      setLoading(true);
      logEvent('User', 'Login Attempt', 'Google Login');

      const token = credentialResponse.credential;

      const response = await axios.post(
        ApiCollection.user.getaAuthUser,
        {
          organisation: "NeuroBridge"
        },
        {
          headers: {
            providerToken: token,
            provider: "GOOGLE",
            version: 'v0'
          }
        }
      );

      const { data: userData } = response;

      if (!userData) {
        throw new Error("No data received from server");
      }

      const userInfo: LocalUser = {
        id: userData.id,
        firstName: userData.first_name,
        lastName: userData.last_name,
        email: userData.email,
        isActive: userData.is_active,
        mobileNo: userData.mobile_number,
        token: userData.token,
        permissions: userData.permissions,
        role: userData.user_role,
        profile: userData.profile,
        dateOfBirth: userData.date_of_birth,
        organisation: {
          id: userData.organisations.id,
          name: userData.organisations.organisation_name,
          address: userData.organisations.organisation_address,
          contact: userData.organisations.organisation_contact_number,
          logo: null
        },
        educationalInfo: Array.isArray(userData.educational_info) ? undefined : userData.educational_info,
        subscription: null
      };

      await tagUser({
        id: userData.id,
        email: userData.email,
        user_role: userData.user_role,
        mobile_number: userData.mobile_number,
        first_name: userData.first_name,
        last_name: userData.last_name,
        educational_info: {
          class: userData.educational_info?.class
        }
      });

      dispatch(setActiveUser(userInfo));

      if (window.OneSignal) {
        try {
          await window.OneSignal.showSlidedownPrompt();
        } catch (error) {
          console.error('Error showing OneSignal prompt:', error);
        }
      }

      logUserLogin({
        userId: userData?.id,
        email: userData?.email,
        name: `${userData?.first_name} ${userData?.last_name}`,
        user_role: userData?.user_role,
        mobile_number: userData?.mobile_number,
        first_name: userData?.first_name,
        last_name: userData?.last_name,
        educational_info: {
          class: userData?.educational_info?.class
        }
      });

      logEvent('User', 'Login Success', 'Google Login');
      navigate('/');
      toast.success('Login successful!');

    } catch (error: any) {
      logEvent('Error', 'Login Failed', 'Google Login');
      console.error('Google login error:', error);
      const errorMessage = error.response?.data?.message || "An error occurred during Google login";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <div className="login-container">

      <div className="login-content">
        <div className="login-left">
          <div className="pattern-overlay"></div>
          <div className="corner-accent"></div>
          <div className="diagonal-accent"></div>
          <div className="floating-shapes">
            <div className="shape"></div>
            <div className="shape"></div>
            <div className="shape"></div>
          </div>
          <div className="overview-image-container">
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={4000}
              showDots={true}
              removeArrowOnDeviceType={["tablet", "mobile"]}
              className="carousel-container"
              customTransition="transform 500ms ease-in-out"
              transitionDuration={500}
              containerClass="carousel-container"
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item"
            >

              <div className="carousel-item">
                <img
                  src={assessmentsPaper}
                  alt="Smart Assessments"
                  className="overview-image"
                />
              </div>

              <div className="carousel-item">
                <img
                  src={paperanalysis}
                  alt="AI-Powered Paper Analysis"
                  className="overview-image"
                />
              </div>

            </Carousel>
          </div>
          <div className="feature-highlights">
            <div className="feature-highlight">
              <div className="feature-highlight-icon">
                <FaRobot />
              </div>
              <div className="feature-highlight-text">
                AI Predicted Question Paper
              </div>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight-icon">
                <FaBookReader />
              </div>
              <div className="feature-highlight-text">
                AI Grading
              </div>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight-icon">
                <FaBrain />
              </div>
              <div className="feature-highlight-text">
                Analysis
              </div>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight-icon">
                <FaChartLine />
              </div>
              <div className="feature-highlight-text">
                Recommendations
              </div>
            </div>
          </div>
        </div>

        <div className="login-right">

          <div className="login-right-content">
            <div className="welcome-text">
              <img
                src={logoSvg}
                alt="Logo"
                className="login-logo"
              />
              <h1>Your Last minute Prep Companion
              </h1>
              <p>Ace Your CBSE Exams with AI-Powered Practice</p>

            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                    if (errors.username) setErrors({ ...errors, username: '' });
                  }}
                  className={errors.username ? 'error-input' : ''}
                />
                {errors.username && <span className="error-text">{errors.username}</span>}
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Enter your password"
                  value={password}
                  autoComplete="current-password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (errors.password) setErrors({ ...errors, password: '' });
                  }}
                  className={errors.password ? 'error-input' : ''}
                />
                {errors.password && <span className="error-text">{errors.password}</span>}
                <div className="forgot-password-container-signin">
                  <Link to="/forgot-password" className="forgot-password-link-signin">Forgot Password?</Link>
                </div>
              </div>
              <button type="submit" disabled={loading}>
                {loading ? <Spinner /> : 'Login'}
              </button>
              <div className="divider">
                <span>OR</span>
              </div>

              <div className="social-login">
                <GoogleLogin
                  type="standard"
                  size="large"
                  width={300}
                  text="continue_with"
                  shape="pill"
                  useOneTap={false}
                  onSuccess={handleGoogleLogin}
                  onError={() => {
                    console.error('Google login failed');
                    toast.error('Google login failed. Please try again.');
                  }}
                />
              </div>

              <div className="signin-text" onClick={() => navigate('/signup')}>
                Don't have an account? <span
                  style={{ color: '#FF6B00', cursor: 'pointer', textDecoration: 'underline' }}
                >Sign up</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
